import React, { useEffect, useState } from 'react';
import { Modal, Select } from 'antd';
import { STATUS } from '../../../../redux/constants';
import { incrementUIRequestsCounter } from '../../../../redux/utils/websocket/incrementUIRequestsCounter';

function EnrichmentExistingFeedCollectionSaveModal({
  typeOfContainer,
  iocType,
  setIsEnrichSaveFeedCollectionModalVisible,
  isEnrichSaveFeedCollectionModalVisible,
  handleSave,
  props,
}) {
  const [selectedFeed, setSelectedFeed] = useState('');
  const capitalize = (s) => s?.[0]?.toUpperCase() + s?.substring(1);
  const iocTypeMap = {
    ip: 'IP',
    ipv4: 'IP',
    domain: 'domain',
    url: 'URL',
  };

  useEffect(() => {
    if (!iocType && !typeOfContainer) return () => {};
    if (iocType?.toLowerCase() == 'ip') {
      props.loadIPEditableFeeds({
        state: typeOfContainer?.toUpperCase(),
      });
    } else if (iocType?.toLowerCase() == 'ipv4') {
      props.loadIPEditableFeeds({
        state: typeOfContainer?.toUpperCase(),
      });
    } else if (iocType?.toLowerCase() == 'domain') {
      props.loadDomainEditableFeeds({
        state: typeOfContainer?.toUpperCase(),
      });
    } else if (iocType?.toLowerCase() == 'url') {
      props.loadURLEditableFeeds({
        state: typeOfContainer?.toUpperCase(),
      });
    }
  }, [iocType, typeOfContainer]);

  return (
    <Modal
      bodyStyle={{ minHeight: 236, padding: 24 }}
      title={`Save to existing ${typeOfContainer}`}
      visible={isEnrichSaveFeedCollectionModalVisible}
      onOk={() => {
        setIsEnrichSaveFeedCollectionModalVisible(false);
        handleSave(selectedFeed);
        incrementUIRequestsCounter();
      }}
      okButtonProps={{
        disabled: !!!selectedFeed,
      }}
      onCancel={() => setIsEnrichSaveFeedCollectionModalVisible(false)}
      okText="Save"
    >
      <h3
        style={{
          fontWeight: 600,
          fontSize: 14,
          color: 'rgba(255, 255, 255, 0.95)',
        }}
      >
        Add {iocTypeMap?.[iocType]} to existing {typeOfContainer}
      </h3>
      <span
        style={{
          fontWeight: 400,
          fontSize: 14,
          marginBottom: 4,
          display: 'block',
          color: 'rgba(255, 255, 255, 0.95)',
          marginLeft: 8,
        }}
      >
        {capitalize(typeOfContainer)} for {iocTypeMap?.[iocType]} (required)
      </span>
      <Select
        role="button"
        aria-label="ipFeeds"
        allowClear
        showSearch
        loading={
          iocType?.toLowerCase() == 'ip'
            ? props.IPEditableFeedsStatus != STATUS.LOADED
            : iocType?.toLowerCase() == 'ipv4'
            ? props.IPEditableFeedsStatus != STATUS.LOADED
            : iocType?.toLowerCase() == 'domain'
            ? props.DomainEditableFeedsStatus != STATUS.LOADED
            : iocType?.toLowerCase() == 'url'
            ? props.URLEditableFeedsStatus != STATUS.LOADED
            : false
        }
        placeholder={`Select`}
        style={{ width: '100%' }}
        options={
          iocType?.toLowerCase() == 'ip'
            ? props?.IPEditableFeeds?.map((feed) => ({
                value: feed?.uuid,
                label: feed?.name,
              }))
            : iocType?.toLowerCase() == 'ipv4'
            ? props?.IPEditableFeeds?.map((feed) => ({
                value: feed?.uuid,
                label: feed?.name,
              }))
            : iocType?.toLowerCase() == 'domain'
            ? props?.DomainEditableFeeds?.map((feed) => ({
                value: feed?.uuid,
                label: feed?.name,
              }))
            : iocType?.toLowerCase() == 'url'
            ? props?.URLEditableFeeds?.map((feed) => ({
                value: feed?.uuid,
                label: feed?.name,
              }))
            : null
        }
        onChange={(feedUUID) => setSelectedFeed(feedUUID)}
        filterOption={(inputValue, option) =>
          option?.label?.toLowerCase()?.indexOf(inputValue?.toLowerCase()) > -1
        }
      ></Select>
    </Modal>
  );
}

export default EnrichmentExistingFeedCollectionSaveModal;
